import React, { useState, useEffect } from "react";
import { PlusCircle, Trash2 } from "lucide-react";
import Navbar from "./Navbar";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";

const PharmacyManager = () => {
  const [pharmacies, setPharmacies] = useState([]);
  const [newPharmacies, setNewPharmacies] = useState([
    { pharmacy_name: "", pharmacy_number: "", pharmacy_location: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");


  const fetchchemist = async () => {
    try {
      const res = await axios.get("https://www.careplus.gopillz.com/new_add-chemist", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setPharmacies(res.data.chemist_list)
    } catch (err) {
      console.error("Error fetching labs:", err);
    }
  };

  useEffect(() => {
    fetchchemist()

  }, []);

  const handleChange = (index, key, value) => {
    const updated = [...newPharmacies];
    updated[index][key] = value;
    setNewPharmacies(updated);
  };

  const addPharmacyField = () => {
    setNewPharmacies([
      ...newPharmacies,
      { pharmacy_name: "", pharmacy_number: "", pharmacy_location: "" },
    ]);
  };

  const removePharmacyField = (index) => {
    const updated = [...newPharmacies];
    updated.splice(index, 1);
    setNewPharmacies(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      pharmacy_name: newPharmacies.map((p) => p.pharmacy_name),
      pharmacy_number: newPharmacies.map((p) => p.pharmacy_number),
      pharmacy_location: newPharmacies.map((p) => p.pharmacy_location),
    };

    try {
      const res = await axios.post(
        "https://www.careplus.gopillz.com/new_add-chemist",
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setMessage(res.data.message);
      setPharmacies([...pharmacies, ...newPharmacies]);
      setNewPharmacies([
        { pharmacy_name: "", pharmacy_number: "", pharmacy_location: "" },
      ]);
      fetchchemist()
    } catch (error) {
      setMessage(error.response?.data?.error || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // Filter logic for search
  const filteredPharmacies = pharmacies.filter(
    (pharmacy) =>
      pharmacy.chemist_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      pharmacy.chemist_number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      pharmacy.chemist_location?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-blue-50 min-h-screen">
      <Navbar />
      <div className="flex justify-center items-start px-4 pt-24 pb-10 min-h-screen">
        <div className="w-full max-w-6xl space-y-10">
          {/* Header */}
          <div className="text-center">
            <h1 className="text-4xl font-bold text-blue-700 mb-2">💊 Pharmacy Manager</h1>
            <p className="text-gray-600">Manage your pharmacy partners effectively</p>
          </div>

          {/* Search */}
          <div className="flex justify-center">
            <input
              type="text"
              placeholder="Search by pharmacy name , phone or pharmacy location"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full max-w-md px-4 py-2 rounded-lg border border-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Pharmacy List */}
          <section className="bg-white rounded-2xl shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Existing Pharmacies</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredPharmacies.length === 0 ? (
                <p className="text-gray-500 col-span-full">No pharmacies match your search.</p>
              ) : (
                filteredPharmacies.map((pharmacy, index) => (
                  <div
                    key={index}
                    className="bg-green-100 border border-green-200 rounded-xl p-4 hover:shadow-lg transition"
                  >
                    <h3 className="text-lg font-semibold text-green-900 mb-1">
                      {pharmacy.chemist_name}
                    </h3>
                    <p className="text-sm text-green-800">📞 {pharmacy.chemist_number}</p>
                    <p className="text-sm text-green-800 mt-1">📍 {pharmacy.chemist_location}</p>
                  </div>
                ))
              )}
            </div>
          </section>

          {/* Add Pharmacy Form */}
          <section className="bg-white rounded-2xl shadow-md p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">➕ Add New Pharmacy</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              {newPharmacies.map((pharmacy, index) => (
                <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                  <input
                    type="text"
                    placeholder="Pharmacy Name"
                    value={pharmacy.pharmacy_name}
                    onChange={(e) => handleChange(index, "pharmacy_name", e.target.value)}
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                    required
                  />

                  <PhoneInput
                    country="in"
                    enableSearch
                    value={pharmacy.pharmacy_number}
                    onChange={(value) => handleChange(index, "pharmacy_number", value)}
                    inputClass="!w-full !px-4 !py-2 !text-sm !border !border-gray-300 !rounded-lg !bg-gray-50"
                    buttonClass="!border-gray-300"
                    containerClass="!w-full"
                  />

                  <input
                    type="text"
                    placeholder="Location"
                    value={pharmacy.pharmacy_location}
                    onChange={(e) => handleChange(index, "pharmacy_location", e.target.value)}
                    className="border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                    required
                  />

                  {newPharmacies.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removePharmacyField(index)}
                      className="text-red-500 hover:text-red-700 text-sm mt-2 sm:mt-0"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  )}
                </div>
              ))}

              <div className="flex flex-wrap items-center gap-4">
                <button
                  type="button"
                  onClick={addPharmacyField}
                  className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
                >
                  <PlusCircle className="w-5 h-5" /> Add Another
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
                >
                  {loading ? "Saving..." : "Submit Pharmacies"}
                </button>
              </div>

              {message && (
                <p className="text-sm font-medium mt-2 text-green-600">{message}</p>
              )}
            </form>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PharmacyManager;
